import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ToolboxIcon = React.forwardRef(function ToolboxIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C2.90228 8 2 8.90228 2 10V20H22V10C22 8.90228 21.0977 8 20 8H4ZM0 10C0 7.79772 1.79772 6 4 6H20C22.2023 6 24 7.79772 24 10V21C24 21.5523 23.5523 22 23 22H1C0.447715 22 0 21.5523 0 21V10Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 14H1V12H23V14ZM6 5C6 3.34772 7.34772 2 9 2H15C16.6523 2 18 3.34772 18 5V7H16V5C16 4.45228 15.5477 4 15 4H9C8.45228 4 8 4.45228 8 5V7H6V5Z"
      ></path>
    </svg>
  )
})

ToolboxIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ToolboxIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ToolboxIcon
